$(function () {

  'use strict';

  // jQuery Hammer.js Integration
  (function (factory) {
    if (typeof define === 'function' && define.amd) {
      define(['jquery', 'hammerjs'], factory);
    } else if (typeof exports === 'object') {
      factory(require('jquery'), require('hammerjs'));
    } else {
      factory(jQuery, Hammer);
    }
  }(function ($, Hammer) {
    function hammerify(el, options) {
      var $el = $(el);
      if (!$el.data("hammer")) {
        $el.data("hammer", new Hammer($el[0], options));
      }
    }

    $.fn.hammer = function (options) {
      return this.each(function () {
        hammerify(this, options);
      });
    };

    // extend the emit method to also trigger jQuery events
    Hammer.Manager.prototype.emit = (function (originalEmit) {
      return function (type, data) {
        originalEmit.call(this, type, data);
        $(this.element).trigger({
          type: type,
          gesture: data
        });
      };
    })(Hammer.Manager.prototype.emit);
  }));

  var classCallCheck = function (instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  };

  var createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var Sections = function () {
    function Sections() {

      classCallCheck(this, Sections);

      this.handlers = {};
      this.instances = {};
      this._onSectionEvent = this._onSectionEvent.bind(this);
      document.addEventListener('shopify:section:load', this._onSectionEvent);
      document.addEventListener('shopify:section:unload', this._onSectionEvent);
      document.addEventListener('shopify:section:select', this._onSectionEvent);
      document.addEventListener('shopify:section:deselect', this._onSectionEvent);
      document.addEventListener('shopify:block:select', this._onSectionEvent);
      document.addEventListener('shopify:block:deselect', this._onSectionEvent);
    }

    /**
     * Stop listening for section events, and unbind all handlers.
     */


    createClass(Sections, [{
      key: 'unbind',
      value: function unbind() {
        document.removeEventListener('shopify:section:load', this._onSectionEvent);
        document.removeEventListener('shopify:section:unload', this._onSectionEvent);
        document.removeEventListener('shopify:section:select', this._onSectionEvent);
        document.removeEventListener('shopify:section:deselect', this._onSectionEvent);
        document.removeEventListener('shopify:block:select', this._onSectionEvent);
        document.removeEventListener('shopify:block:deselect', this._onSectionEvent);

        // Unload all instances
        for (var i = 0; i < this.instances.length; i++) {
          this._triggerInstanceEvent(this.instances[i], 'onSectionUnload');
        }

        this.handlers = {};
        this.instances = {};
      }

      /**
       * Register a section handler.
       *
       * @param {string} type
       *        The section type to handle. The handler will be called for all
       *        sections with this type.
       *
       * @param {function} handler
       *        The handler function is passed information about a specific section
       *        instance. The handler is expected to return an object that will be
       *        associated with the section instance.
       *
       *        Section handlers are passed an object with the following parameters:
       *          {string} id
       *          An ID that maps to a specific section instance. Typically the
       *          section's filename for static sections, or a generated ID for
       *          dynamic sections.
       *
       *          {string} type
       *          The section type, as supplied when registered.
       *
       *          {Element} el
       *          The root DOM element for the section instance.
       *
       *          {Object} data
       *          Data loaded from the section script element. Defaults to an
       *          empty object.
       *
       *          {Function} postMessage
       *          A function that can be called to pass messages between sections.
       *          The function should be called with a message "name", and
       *          optionally some data.
       */

    }, {
      key: 'register',
      value: function register(type, handler) {
        if (this.handlers[type]) {
          console.warn('Sections: section handler already exists of type \'' + type + '\'.');
        }

        // Store the section handler
        this.handlers[type] = handler;

        // Init sections for this type
        this._initSections(type);
      }

      /**
       * Initialize sections already on the page.
       */

    }, {
      key: '_initSections',
      value: function _initSections(type) {
        // Fetch all existing sections of our type on the page
        var dataEls = document.querySelectorAll('[data-section-type="' + type + '"]');
        if (!dataEls) return;

        // Create an instance for each section
        for (var i = 0; i < dataEls.length; i++) {
          var dataEl = dataEls[i];
          var el = dataEl.parentNode;

          // Get instance ID
          var idEl = el.querySelector('[data-section-id]');

          if (!idEl) {
            console.warn('Sections: unable to find section id for \'' + type + '\'.', el);
            continue;
          }

          var sectionId = idEl.getAttribute('data-section-id');
          if (!sectionId) {
            console.warn('Sections: unable to find section id for \'' + type + '\'.', el);
            continue;
          }

          this._createInstance(sectionId, el);
        }
      }
    }, {
      key: '_onSectionEvent',
      value: function _onSectionEvent(event) {
        var el = event.target;
        var sectionId = event.detail.sectionId;
        var blockId = event.detail.blockId;
        var instance = this.instances[sectionId];

        switch (event.type) {
          case 'shopify:section:load':
            this._createInstance(sectionId, el);
            break;

          case 'shopify:section:unload':
            this._triggerInstanceEvent(instance, 'onSectionUnload', {
              el: el,
              id: sectionId
            });
            delete this.instances[sectionId];
            break;

          case 'shopify:section:select':
            this._triggerInstanceEvent(instance, 'onSectionSelect', {
              el: el,
              id: sectionId
            });
            break;

          case 'shopify:section:deselect':
            this._triggerInstanceEvent(instance, 'onSectionDeselect', {
              el: el,
              id: sectionId
            });
            break;

          case 'shopify:block:select':
            this._triggerInstanceEvent(instance, 'onSectionBlockSelect', {
              el: el,
              id: blockId
            });
            break;

          case 'shopify:block:deselect':
            this._triggerInstanceEvent(instance, 'onSectionBlockDeselect', {
              el: el,
              id: blockId
            });
            break;
        }
      }
    }, {
      key: '_triggerInstanceEvent',
      value: function _triggerInstanceEvent(instance, eventName) {
        if (instance && instance[eventName]) {
          for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
            args[_key - 2] = arguments[_key];
          }

          instance[eventName].apply(instance, args);
        }
      }
    }, {
      key: '_postMessage',
      value: function _postMessage(name, data) {
        var _this = this;

        Object.keys(this.instances).forEach(function (id) {
          _this._triggerInstanceEvent(_this.instances[id], 'onSectionMessage', name, data);
        });
      }
    }, {
      key: '_createInstance',
      value: function _createInstance(id, el) {
        var typeEl = el.querySelector('[data-section-type]');
        if (!typeEl) return;

        var type = typeEl.getAttribute('data-section-type');
        if (!type) return;

        var handler = this.handlers[type];
        if (!handler) return console.warn('Sections: unable to find section handler for type \'' + type + '\'.');

        var data = this._loadData(el);
        var postMessage = this._postMessage.bind(this);

        this.instances[id] = handler({
          id: id,
          type: type,
          el: el,
          data: data,
          postMessage: postMessage
        });
      }
    }, {
      key: '_loadData',
      value: function _loadData(el) {
        var dataEl = el.querySelector('[data-section-data]');
        if (!dataEl) return {};

        // Load data from attribute, or innerHTML
        var data = dataEl.getAttribute('data-section-data') || dataEl.innerHTML;

        try {
          return JSON.parse(data);
        } catch (error) {
          console.warn('Sections: invalid section data found. ' + error.message);
          return {};
        }
      }
    }]);
    return Sections;
  }();

  var StaticProduct = function () {
    function StaticProduct(section) {
      var _this = this;

      classCallCheck(this, StaticProduct);

      this.postMessage = section.postMessage;
      this.$el = $(section.el);
      this.$window = $(window);
      this.$product = this.$el.find('[data-product-wrapper]');
      this.$productDetails = this.$el.find('[data-product-details]');
      this.productDetailsWidth = this.$productDetails.width();
      this.$description = this.$product.find('[data-product-description]');
      this.$descriptionContent = this.$product.find('[data-product-description] .book-excerpt');
      this.descriptionHeight = this.$descriptionContent.height();
      this.descriptionMaxHeight = parseInt(this.$descriptionContent.find('p').first().css('line-height'), 10) * (section.data.settings.description_min_height + 1) - 3;

      this._truncateDescription(section);

      this.$titleByLine = this.$el.find('[data-product-title-byline]');
      this.$moreAuthors = this.$titleByLine.find('.more');
      this.moreAuthorsWidth = this.$moreAuthors.width();
      this.truncateTitleByLine = this._truncateTitleByLine.bind(this);
      this.truncateTitleByLine();
      this.$window.on('resize', this.truncateTitleByLine);

      this._watchSubscriptionType = this._watchSubscriptionType.bind(this);

      this.data = section.data;

      if (this.data.product.vendor == 'Abo') {
        this.deliveryTermsSelect = $('select#subscription_type');
        this.deliveryTermsText = $('#lieferbedingungen p');
        this._watchSubscriptionType();
      } else if (this.data.product.vendor == 'Digital' || this.data.product.vendor == 'Print') {
        this.typeRadioInput = $('input[name=product_type]');
        this._watchType();
      }

      $(window).on("popstate", function (e) {
        if (e.originalEvent.state !== null) {
          location.reload()
        }
      });

    }

    createClass(StaticProduct, [{
      key: '_watchType',
      value: function _watchType() {
        var _this = this;
        this.typeRadioInput.on('change', function () {

          var available = $(this).data('available') == "1";
          var button_text = available == true ? "In den Warenkorb" : "Jetzt vorbestellen";
          var button_disabled = false;

          $('.product-form--atc-button').css('display', 'block');
          $('.affiliate-container').css('display', 'none');

          if ($(this).data('product-type') == "Print") {
            button_text = "Demnächst erhältlich";
            button_disabled = true;
            $('.affiliate-container.print').css('display', 'block');
            if (available) {
              $('.product-form--atc-button').css('display', 'none');
            }
          }
          else if($(this).data('product-type') == "Digital"){
            $('.affiliate-container.digital').css('display', 'block');
          }
          else {
            if (!available) {
              $('#preorder-shopify_variant_id').val($('input[name="product_type"]').data('variant-id'));
            }
          }

          $('.atc-button--text').html(button_text);
          $('.product-form--atc-button').attr('disabled', button_disabled);

          var chosen_isbn = $(this).data('isbn');
          var chosen_meta, chosen_product;

          if (_this.data.product_meta.isbn == chosen_isbn) {
            chosen_meta = _this.data.product_meta;
            chosen_product = _this.data.product;
          } else if (_this.data.related_product_meta.isbn == chosen_isbn) {
            chosen_meta = _this.data.related_product_meta;
            chosen_product = _this.data.related_product;
          }

          if (chosen_meta.publication_date) {
            $('#pub-date').html(chosen_meta.publication_date);
          }
          if (chosen_meta.series_number) {
            $('#series-num').html(chosen_meta.series_number);
          }
          if (chosen_meta.page_number) {
            $('#page-num').html(chosen_meta.page_number);
          }
          if (chosen_meta.isbn) {
            $('#isbn-num').html(chosen_meta.isbn);
          }
          if (chosen_meta.altersempfehlung) {
            $('#years-num').html(chosen_meta.altersempfehlung);
          }
          if (chosen_meta.format) {
            $('#format-string').html(chosen_meta.format);
          }

          if (chosen_meta.vendor == 'Print') {
            $('#ebook-format').css("display", 'none');
            $('#ebook-send').css("display", 'none');
          } else {
            $('#ebook-format').css("display", '');
            $('#ebook-send').css("display", '');
          }

          // change the product image on product change
          if (_this.data.product_meta.isbn != chosen_isbn) {
            $(this).parents(".product--outer").find(".product-image img").attr("src", _this.data.related_product.featured_image);
          } else {
            $(this).parents(".product--outer").find(".product-image img").attr("src", _this.data.product.featured_image);
          }

          history.pushState({}, chosen_product.title, '/products/' + chosen_product.handle);
          // history.replaceState({}, chosen_product.title, '/products/' + chosen_product.handle);
          // return window.location = '/products/' + $(this).data('handle');

        });
      }
    }, {
      key: '_watchSubscriptionType',
      value: function _watchSubscriptionType() {
        var _this = this;
        var productIsMiniabo = this.data.product.handle.indexOf('-miniabo') !== -1;

        if (window.location.hash != '') {
          switch (window.location.hash) {
            case '#komfortabo':
              this.deliveryTermsSelect.val("Komfortabo");
              break;
            case '#geschenkabo':
              this.deliveryTermsSelect.val("Geschenkabo");
              break;
          }
        }

        this.deliveryTermsSelect.change(function () {
          var selectValue = $(this).find("option:selected").attr('value');
          var $text;
          if (selectValue == 'Geschenkabo') {
            if (productIsMiniabo) {
              return window.location = '/products/' + _this.data.product.handle.replace("-miniabo", "-abo") + '/#geschenkabo';
            } else {
              var $text = $($.parseHTML(_this.data.delivery_terms.geschenkabo));
            }
          } else if (selectValue == 'Komfortabo') {
            if (productIsMiniabo) {
              return window.location = '/products/' + _this.data.product.handle.replace("-miniabo", "-abo") + '/#komfortabo';
            } else {
              var $text = $($.parseHTML(_this.data.delivery_terms.komfortabo));
            }
          } else if (selectValue == 'Miniabo') {
            if (!productIsMiniabo) {
              return window.location = '/products/' + _this.data.product.handle.replace("-abo", "-miniabo");
            }
          }
          _this.deliveryTermsText.html($text);
        });
      }
    }, {
      key: '_truncateDescription',
      value: function _truncateDescription(section) {
        if (this.descriptionHeight > this.descriptionMaxHeight) {
          $('<button class="btn primaryborder open-description"><i class="fal fa-chevron-left"></i> <span>' + section.data.settings.read_more + '</span></button>').insertAfter(this.$descriptionContent);
          this.$descriptionContent.height(this.descriptionMaxHeight + 'px');
          this.$descriptionContent.toggleClass('closed');
          var _this = this;
          $(".open-description").click(function () {
            var size = null;
            var btntext = null;
            Math.round(_this.$descriptionContent.height()) == _this.descriptionMaxHeight ? size = _this.descriptionHeight : size = _this.descriptionMaxHeight;
            Math.round(_this.$descriptionContent.height()) == _this.descriptionMaxHeight ? btntext = '<i class="fal fa-chevron-right"></i> <span>' + section.data.settings.close_more + '</span>' : btntext = '<i class="fal fa-chevron-left"></i> <span>' + section.data.settings.read_more + '</span>';
            _this.$descriptionContent.animate({
              height: size + 'px'
            }, 500);
            $(this).html(btntext);
            _this.$descriptionContent.toggleClass('closed');
          });
        }
      }
    }, {
      key: '_truncateTitleByLine',
      value: function _truncateTitleByLine(section) {

        var _this = this;

        this.productDetailsWidth = this.$productDetails.width();
        this.moreAuthorsWidth = this.$moreAuthors.width();

        var possibleWidth = 30 + this.moreAuthorsWidth; // "von" mit 30px eingerechnet

        var blocks = [];
        var hiddenEls = [];

        this.$titleByLine.find('span.author').each(function (index, el) {
          blocks.push({
            width: $(this).width(),
            el: $(this)
          });
        });

        for (let i = 0; i < blocks.length; i++) {
          var block = blocks[i];
          possibleWidth = possibleWidth + block.width;
          // console.log(possibleWidth);
          if (this.productDetailsWidth < possibleWidth) {
            block.el.attr("style", "display: none;");
            block.el.removeClass("notFaded");
            hiddenEls.push(block);
          } else {
            block.el.attr("style", "display: inline-block;");
            block.el.addClass("notFaded");
          }
        }

        if (this.$moreAuthors.attr("style") == "display: none;" && hiddenEls.length > 0) {
          this.$moreAuthors.attr("style", "display: inline-block;");
        }
        this.$moreAuthors.find(".count").html(hiddenEls.length);


        this.$moreAuthors.find("a").click(function (event) {
          var _this2 = _this;
          event.preventDefault();
          _this.$titleByLine.find("span.author").each(function () {
            if (!$(this).hasClass("notFaded")) {
              $(this).addClass("notFaded");
              $(this).attr("style", "display: inline-block;");
            }
            _this.$moreAuthors.remove();
          })
        })

      }
    }]);
    return StaticProduct;
  }();

  // var Products = function () {
  //     function Products($els) {
  //         classCallCheck(this, Products);
  //         this._loadProducts = this._loadProducts.bind(this);
  //         this._loadProducts($els);
  //     }
  //     createClass(Products, [{
  //         key: '_loadProducts',
  //         value: function _loadProducts($els) {
  //             $els.each(function() {
  //                 return new Product($(this));
  //             });
  //         }
  //     }]);
  //     return Products;
  // }();











  //-------------------------------------------
  //-------------------------------------------
  //
  //
  // SLIDERS
  //
  //
  //-------------------------------------------
  //-------------------------------------------


  var Slider = function () {
    function Slider($el) {
      classCallCheck(this, Slider);

      this.$el = $el;
      this.$window = $(window);

      this.data = this._loadData(this.$el);

      this.$swiper = null;

      this.$swpr_root = this.$el.find('.swpr');
      this.$swpr_root_initClass = this.$swpr_root.attr('class');

      this.$swpr_container = this.$el.find('.swpr-container');
      this.$swpr_container_initClass = this.$swpr_container.attr('class');

      this.$swpr_wrapper = this.$el.find('.swpr-wrapper');
      this.$swpr_wrapper_initClass = this.$swpr_wrapper.attr('class');

      this.$swpr_pagination = this.$el.find('.swpr-pagination');
      this.$swpr_pagination_initClass = this.$swpr_pagination.attr('class');

      this.$swpr_slides = this.$el.find('.swpr-slide');
      this.$swpr_slides_initClass = this.$swpr_slides.attr('class');

      this.$swpr_prevEl = this.$el.find('.swpr-btn-prev');
      this.$swpr_prevEl_initClass = this.$swpr_prevEl.attr('class');

      this.$swpr_nextEl = this.$el.find('.swpr-btn-next');
      this.$swpr_nextEl_initClass = this.$swpr_nextEl.attr('class');

      this.maybeSliderBreakpoint = null;

      this._maybeSlider = this._maybeSlider.bind(this);
      this._initSlider = this._initSlider.bind(this);
      this._resetSlider = this._resetSlider.bind(this);
      this._checkIfInitSlider = this._checkIfInitSlider.bind(this);

      this._maybeSlider();

    }
    createClass(Slider, [{
      key: '_loadData',
      value: function _loadData($el) {
        var dataEl = $el.find('[data-settings]')
        if (!dataEl.length) return {};
        // Load data from innerHTML
        var data = dataEl.html();
        try {
          return JSON.parse(data);
        } catch (error) {
          console.warn('Sections: invalid slider data found. ' + error.message);
          return {};
        }
      }
    }, {
      key: '_maybeSlider',
      value: function _maybeSlider() {
        if (this.data.elements == 1) {
          this.$el.addClass('no-slider');
          this.$el.removeClass('loading');
        } else {
          this.$el.addClass('breakpoint-swiper');
          if (this.data.elements <= this.data.maxItemsPerView) {
            this.$el.addClass('not-active');
          }
          if (this.data.trigger_swiper || this.data.elements <= 3) {
            this.maybeSliderBreakpoint = this.data.mediaqueries['bp-small'];
          } else {
            if (this.data.elements == 4) {
              this.maybeSliderBreakpoint = this.data.mediaqueries['bp-medium'];
            } else if (this.data.elements == 5) {
              this.maybeSliderBreakpoint = this.data.mediaqueries['bp-large_home'];
            } else if (this.data.elements >= 6) {
              this.maybeSliderBreakpoint = 10000;
            }
          }
          this._checkIfInitSlider();
          this.$window.on('resize', this._checkIfInitSlider);
        }
      }
    }, {
      key: '_checkIfInitSlider',
      value: function _checkIfInitSlider() {
        if (this.$window.width() < this.maybeSliderBreakpoint) {
          if (!this.$swiper) {
            this._initSlider();
          }
        } else {
          if (this.$swiper) {
            this._resetSlider();
          }
        }
        this.$el.removeClass('loading');
      }
    }, {
      key: '_resetSlider',
      value: function _resetSlider() {

        var _this = this;

        this.$swiper.destroy(true, true);
        this.$swiper = null;
        this.$swpr_prevEl.removeAttr('class');
        this.$swpr_prevEl.addClass(this.$swpr_prevEl_initClass);
        // this.$swpr_prevEl.addClass('swpr-btn-prev');
        this.$swpr_nextEl.removeAttr('class');
        this.$swpr_nextEl.addClass(this.$swpr_nextEl_initClass);
        // this.$swpr_nextEl.addClass('swpr-btn-next');
        this.$swpr_root.removeAttr('class');
        this.$swpr_root.addClass(this.$swpr_root_initClass);
        // this.$swpr_root.addClass('swpr');
        this.$swpr_container.removeAttr('class');
        this.$swpr_container.addClass(this.$swpr_container_initClass);
        // this.$swpr_container.addClass('swpr-container');
        this.$swpr_wrapper.removeAttr('class');
        this.$swpr_wrapper.removeAttr('style');
        this.$swpr_wrapper.addClass(this.$swpr_wrapper_initClass);
        // this.$swpr_wrapper.addClass('swpr-wrapper');
        this.$swpr_slides.each(function (index, el) {
          $(this).removeAttr('class');
          $(this).removeAttr('style');
          $(this).addClass('swpr-slide');
          switch (index) {
            case 0:
              $(this).addClass('one');
              break;
            case 1:
              $(this).addClass('two');
              break;
            case 2:
              $(this).addClass('three');
              break;
            case 3:
              $(this).addClass('four');
              break;
            default:
              $(this).addClass('five');
              break;
          }
        })
        $('<div class="swpr-pagination"></div>').insertAfter(this.$swpr_pagination);
        this.$swpr_pagination.remove();
        this.$swpr_pagination = $('.swpr-pagination');
        $('.swiper-notification').remove();
        $('swiper-pagination-bullet').remove();
        this.$el.removeClass('is-active');
        this.$el.addClass('not-active');
      }
    }, {
      key: '_initSlider',
      value: function _initSlider() {

        var _this = this;

        this.$swpr_root.removeAttr('class');
        this.$swpr_root.addClass('swiper');
        this.$swpr_container.removeAttr('class');
        this.$swpr_container.addClass('swiper-container');
        this.$swpr_wrapper.removeAttr('class');
        this.$swpr_wrapper.addClass('swiper-wrapper');
        this.$swpr_slides.removeAttr('class');
        this.$swpr_slides.addClass('swiper-slide');
        // this.$swpr_slides.addClass('swiper-slide el-product');
        this.$swpr_pagination.removeAttr('class');
        this.$swpr_pagination.addClass('swiper-pagination');
        this.$swpr_prevEl.removeAttr('class');
        this.$swpr_prevEl.addClass('swiper-btn-prev');
        this.$swpr_nextEl.removeAttr('class');
        this.$swpr_nextEl.addClass('swiper-btn-next');

        let pagination
        if ($('body').hasClass('dragonfly')) {
          pagination = {
            el: this.$swpr_pagination,
            clickable: true,
            renderBullet: function (index, className) {
              //console.log("Index "+index);
              return '<span class="' + className + '"><svg class="unactive" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" width="197.68" height="191.03" viewBox="0 0 197.68 191.03"><path d="M181.23,66.54c-3.94-16.9-11.61-32.74-23.12-45.37-24.57-27-64.52-26.72-93.78-7.47A79.32,79.32,0,0,0,41.18,37.47C20.41,49.5,3.41,69.28.38,93.07c-3.14,24.66,13.69,38.39,34,45.2,7.59,32.42,36.46,54.52,70.13,52.65,22.42-1.25,40.22-10.46,53.28-24.27,12.54-6.09,23.42-14.56,30.79-25.22C205,117.69,197.16,88.16,181.23,66.54ZM130.51,6.83C155.42,14.37,170.1,36.55,177,61.18c-.83-1-1.66-1.91-2.51-2.84-27-29.22-71.91-40.84-109.92-30.65A95.1,95.1,0,0,0,51.89,32.1C70.81,9.88,101-2.12,130.51,6.83Zm50.77,100.69c-1.76,20-9.32,38.49-21.23,52.77-11.33,5.56-24.11,8.75-36,10.64-21.6,3.45-43.57,1-61.86-11.69A65.81,65.81,0,0,1,44.65,141.1a124,124,0,0,0,24.21,2.79c1.48,0-19.3-3.75-26.79-7a80.89,80.89,0,0,1-7.07-17C38.72,65.82,82.13,42.5,81.1,43,53.59,56.3,35.82,81.35,32.75,110.25A105.66,105.66,0,0,1,36.32,59.7,81.39,81.39,0,0,1,45.92,40c28.94-15.62,66.38-15,96.22-1a99.59,99.59,0,0,1,36.8,30.3A133.48,133.48,0,0,1,181.28,107.52Zm-172,6.11c-8.5-15.44-1.73-34.2,7.44-47.55a81.94,81.94,0,0,1,19.55-20A106.63,106.63,0,0,0,26,100.39a91.58,91.58,0,0,0,6.83,28.79c.14,1.22.3,2.44.49,3.67,0,.34.12.67.18,1C23.44,129.66,14.63,123.35,9.28,113.63Zm82.81,74.79C64.71,185.88,45.81,165,38.4,140.21a75.8,75.8,0,0,0,40.72,33.14c21.26,7.22,48.61,5.59,71.79-3.67C135.56,183.1,115.31,190.58,92.09,188.42Zm94-50.88c-5.05,8.54-12.34,15-20.71,19.9C181.42,134.8,187.4,103.93,182.87,75,194.66,93.91,198.51,116.54,186.06,137.54Z"/></svg><svg class="active" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" width="197.68" height="191.03" viewBox="0 0 197.68 191.03"><path d="M181.23,66.54c-3.94-16.9-11.61-32.74-23.12-45.37-24.57-27-64.52-26.72-93.78-7.47A79.32,79.32,0,0,0,41.18,37.47C20.41,49.5,3.41,69.28.38,93.07c-3.14,24.66,13.69,38.39,34,45.2,7.59,32.42,36.46,54.52,70.13,52.65,22.42-1.25,40.22-10.46,53.28-24.27,12.54-6.09,23.42-14.56,30.79-25.22C205,117.69,197.16,88.16,181.23,66.54ZM130.51,6.83C155.42,14.37,170.1,36.55,177,61.18c-.83-1-1.66-1.91-2.51-2.84-27-29.22-71.91-40.84-109.92-30.65A95.1,95.1,0,0,0,51.89,32.1C70.81,9.88,101-2.12,130.51,6.83Zm50.77,100.69c-1.76,20-9.32,38.49-21.23,52.77-11.33,5.56-24.11,8.75-36,10.64-21.6,3.45-43.57,1-61.86-11.69A65.81,65.81,0,0,1,44.65,141.1a124,124,0,0,0,24.21,2.79c1.48,0-19.3-3.75-26.79-7a80.89,80.89,0,0,1-7.07-17C38.72,65.82,82.13,42.5,81.1,43,53.59,56.3,35.82,81.35,32.75,110.25A105.66,105.66,0,0,1,36.32,59.7,81.39,81.39,0,0,1,45.92,40c28.94-15.62,66.38-15,96.22-1a99.59,99.59,0,0,1,36.8,30.3A133.48,133.48,0,0,1,181.28,107.52Zm-172,6.11c-8.5-15.44-1.73-34.2,7.44-47.55a81.94,81.94,0,0,1,19.55-20A106.63,106.63,0,0,0,26,100.39a91.58,91.58,0,0,0,6.83,28.79c.14,1.22.3,2.44.49,3.67,0,.34.12.67.18,1C23.44,129.66,14.63,123.35,9.28,113.63Zm82.81,74.79C64.71,185.88,45.81,165,38.4,140.21a75.8,75.8,0,0,0,40.72,33.14c21.26,7.22,48.61,5.59,71.79-3.67C135.56,183.1,115.31,190.58,92.09,188.42Zm94-50.88c-5.05,8.54-12.34,15-20.71,19.9C181.42,134.8,187.4,103.93,182.87,75,194.66,93.91,198.51,116.54,186.06,137.54Z"/><circle cx="106.62" cy="100.36" r="75"/></svg></span>'
            }
          }
        } else {
          pagination = {
            el: this.$swpr_pagination,
            type: 'progressbar',
            clickable: false,
            renderProgressbar: function (progressbarFillClass) {
              return '<span class="' + progressbarFillClass + '"></span>';
            }
          }
        }

        this.$swiper = new Swiper(this.$swpr_container, {
          slidesPerView: this.data.maxItemsPerView,
          slidesPerGroup: this.data.maxItemsPerView,
          watchSlidesProgress: true,
          watchSlidesVisibility: true,
          preloadImages: true,
          updateOnImagesReady: true,
          spaceBetween: 32,
          direction: 'horizontal',
          loop: false,
          followFinger: $('html').hasClass('has-touch'),
          preventClicks: $('html').hasClass('has-touch'),
          simulateTouch: false,
          init: false,
          centeredSlides: false,
          navigation: {
            nextEl: this.$swpr_nextEl,
            prevEl: this.$swpr_prevEl,
          },
          pagination: pagination,
          breakpoints: this.data.breakpoints,
          on: {
            //   resize: function () {
            //     $('#shopify-section-{{ section.id }} .quickpreview').each(function() {
            //       if (!$(this).hasClass('hide')) {
            //         $(this).addClass('hide');
            //       }
            //     });
            //   },
            touchMove: function (e) {
              this.$el.find('.show-hoverview').removeClass('show-hoverview');
            },
            slideChange: function (e) {
              this.$el.find('.show-hoverview').removeClass('show-hoverview');
            },
            transitionStart: function (e) {
              this.$el.find('.show-hoverview').removeClass('show-hoverview');
            },
            transitionEnd: function (e) {
              this.$el.find('.show-hoverview').removeClass('show-hoverview');
            },
            sliderMove: function (e) {
              this.$el.find('.show-hoverview').removeClass('show-hoverview');
            },
          }
        });

        this.$el.removeClass('loading');
        this.$el.removeClass('not-active');
        this.$el.addClass('is-active');

        this.$swiper.init();

        // console.log(this.$swiper.params.breakpoints);
        // console.log('slidesPerGroup', this.$swiper.params.slidesPerGroup);
        // console.log('slidesPerView', this.$swiper.params.slidesPerView);
        // console.log('spaceBetween', this.$swiper.params.spaceBetween);

      }
    }]);
    return Slider;
  }();

  var SliderHome = function () {
    function SliderHome($el) {
      classCallCheck(this, SliderHome);

      this.$el = $el;
      this.$window = $(window);
      this.data = this._loadData(this.$el);
      this.$swiper = null;
      this._initSlider = this._initSlider.bind(this);
      this._initSlider();

      var _this = this;

      document.addEventListener('shopify:section:load', function (event) {
        console.log('swiper update');
        _this.$swiper.destroy(true, true);
        _this.$swiper = null;
        _this.$el = $('[data-slider-home]');
        _this._initSlider();
      });

      document.addEventListener('shopify:block:select', function (event) {
        $('.home-slider .swiper-slide').each(function () {
          var img_url = 'https:' + $(this).find('img').attr('src');
          $(this).append('<a href="https://www.latori.com/focal-point-editor/?img_url=' + img_url + '" target="_blank" class="url_preview">Open this image in Focal Point Editor</a>');
        });
        var targetIndex = $('.home-slider .swiper-slide-' + event.detail.blockId).data('swiper-slide-index');
        _this.$swiper.slideTo(targetIndex + 1);
        _this.$swiper.autoplay.top();
      });

      document.addEventListener('shopify:block:deselect', function (event) {
        $('.home-slider .url_preview').each(function () {
          $(this).remove();
        });
        _this.$swiper.autoplay.start();
      });

    }
    createClass(SliderHome, [{
      key: '_loadData',
      value: function _loadData($el) {
        var dataEl = $el.find('[data-settings]')
        if (!dataEl.length) return {};
        // Load data from innerHTML
        var data = dataEl.html();
        try {
          return JSON.parse(data);
        } catch (error) {
          console.warn('Sections: invalid slider data found. ' + error.message);
          return {};
        }
      }
    },
    {
      key: '_initSlider',
      value: function _initSlider() {

        var _this = this;

        this.$swpr_root = this.$el.find('.swiper');
        this.$swpr_container = this.$el.find('.swiper-container');
        this.$swpr_wrapper = this.$el.find('.swiper-wrapper');
        this.$swpr_pagination = this.$el.find('.swiper-pagination');
        this.$swpr_slides = this.$el.find('.swiper-slide');
        this.$swpr_prevEl = this.$el.find('.swiper-btn-prev');
        this.$swpr_nextEl = this.$el.find('.swiper-btn-next');

        this.$swiper = new Swiper(this.$swpr_container, {
          slidesPerView: this.data.maxItemsPerView,
          slidesPerGroup: this.data.slidesPerGroup,
          preloadImages: true,
          updateOnImagesReady: true,
          spaceBetween: this.data.spaceBetween,
          direction: 'horizontal',
          autoplay: this.data.autoplay,
          speed: this.data.speed,
          loop: this.data.loop,
          autoHeight: true,
          init: false,
          navigation: {
            nextEl: this.$swpr_nextEl,
            prevEl: this.$swpr_prevEl,
          },
          pagination: {
            el: this.$swpr_pagination,
            type: 'bullets',
          },
          on: {
            transitionStart: function (e) {
              var activeSlide = $(this.$el).find("[data-swiper-slide-index=" + this.realIndex + "]");
              var currentPrimaryColor = activeSlide.data('primary-color');
              _this.$swpr_nextEl.css('color', currentPrimaryColor);
              _this.$swpr_prevEl.css('color', currentPrimaryColor);
              _this.$swpr_prevEl.css('color', currentPrimaryColor);
              _this.$swpr_pagination.css('color', currentPrimaryColor);
            }
          }
        });

        this.$swiper.init();

      }
    }]);
    return SliderHome;
  }();

  var SliderMore = function () {
    function SliderMore($el) {
      classCallCheck(this, SliderMore);

      this.$el = $el;
      this.$window = $(window);

      this.data = this._loadData(this.$el);

      this.$swiper = null;

      this.$swpr_root = this.$el.find('.swpr');
      this.$swpr_root_initClass = this.$swpr_root.attr('class');

      this.$swpr_container = this.$el.find('.swpr-container');
      this.$swpr_container_initClass = this.$swpr_container.attr('class');

      this.$swpr_wrapper = this.$el.find('.swpr-wrapper');
      this.$swpr_wrapper_initClass = this.$swpr_wrapper.attr('class');

      this.$swpr_pagination = this.$el.find('.swpr-pagination');
      this.$swpr_pagination_initClass = this.$swpr_pagination.attr('class');

      this.$swpr_slides = this.$el.find('.swpr-slide');
      this.$swpr_slides_initClass = this.$swpr_slides.attr('class');

      this.$swpr_prevEl = this.$el.find('.swpr-btn-prev');
      this.$swpr_prevEl_initClass = this.$swpr_prevEl.attr('class');

      this.$swpr_nextEl = this.$el.find('.swpr-btn-next');
      this.$swpr_nextEl_initClass = this.$swpr_nextEl.attr('class');

      this.maybeSliderBreakpoint = null;

      this._maybeSlider = this._maybeSlider.bind(this);
      this._initSlider = this._initSlider.bind(this);
      this._resetSlider = this._resetSlider.bind(this);
      this._checkIfInitSlider = this._checkIfInitSlider.bind(this);

      this._maybeSlider();

    }
    createClass(SliderMore, [
      {
        key: '_loadData',
        value: function _loadData($el) {
          var dataEl = $el.find('[data-settings]')
          if (!dataEl.length) return {};
          // Load data from innerHTML
          var data = dataEl.html();
          try {
            return JSON.parse(data);
          } catch (error) {
            console.warn('Sections: invalid slider data found. ' + error.message);
            return {};
          }
        }
      },
      {
        key: '_maybeSlider',
        value: function _maybeSlider() {
          if (this.data.elements > 1) {
            if (this.data.elements == 2) {
              this.$el.addClass('breakpoint-swiper');
              this.maybeSliderBreakpoint = 500;
            } else if (this.data.elements > 2) {
              this.$el.addClass('breakpoint-swiper');
              this.maybeSliderBreakpoint = this.data.trigger_swiper;
              // if (this.data.elements > 3) {
              // this.$el.addClass('gridlex-xs');
              // this.maybeSliderBreakpoint = this.data.mediaqueries['gridlex-xs'];
              // } else if (this.data.elements > 2) {
              // this.$el.addClass('gridlex-min');
              // this.maybeSliderBreakpoint = this.data.mediaqueries['gridlex-min'];
              // }
            }
            this._checkIfInitSlider();
            this.$window.on('resize', this._checkIfInitSlider);
          } else {
            this.$el.addClass('no-slider');
          }
          this.$el.removeClass('loading');
        }
      },
      {
        key: '_checkIfInitSlider',
        value: function _checkIfInitSlider() {
          if (this.$window.width() < this.maybeSliderBreakpoint) {
            if (!this.$swiper) {
              this._initSlider();
            }
          } else {
            if (this.$swiper) {
              this._resetSlider();
            }
          }
        }
      },
      {
        key: '_resetSlider',
        value: function _resetSlider() {

          var _this = this;

          this.$swiper.destroy(true, true);
          this.$swiper = null;
          this.$swpr_prevEl.removeAttr('class');
          this.$swpr_prevEl.addClass(this.$swpr_prevEl_initClass);
          // this.$swpr_prevEl.addClass('swpr-btn-prev');
          this.$swpr_nextEl.removeAttr('class');
          this.$swpr_nextEl.addClass(this.$swpr_nextEl_initClass);
          // this.$swpr_nextEl.addClass('swpr-btn-next');
          this.$swpr_root.removeAttr('class');
          this.$swpr_root.addClass(this.$swpr_root_initClass);
          // this.$swpr_root.addClass('swpr');
          this.$swpr_container.removeAttr('class');
          this.$swpr_container.addClass(this.$swpr_container_initClass);
          // this.$swpr_container.addClass('swpr-container');
          this.$swpr_wrapper.removeAttr('class');
          this.$swpr_wrapper.removeAttr('style');
          this.$swpr_wrapper.addClass(this.$swpr_wrapper_initClass);
          // this.$swpr_wrapper.addClass('swpr-wrapper');
          this.$swpr_slides.each(function (index, el) {
            $(this).removeAttr('class');
            $(this).removeAttr('style');
            $(this).addClass('swpr-slide');
            switch (index) {
              case 0:
                $(this).addClass('one');
                break;
              case 1:
                $(this).addClass('two');
                break;
              case 2:
                $(this).addClass('three');
                break;
              case 3:
                $(this).addClass('four');
                break;
              default:
                $(this).addClass('five');
                break;
            }
            // $(this).addClass('swpr-slide el-product');
            // $(this).addClass(_this.$swpr_slides_initClass);
          })
          $('<div class="swpr-pagination"></div>').insertAfter(this.$swpr_pagination);
          this.$swpr_pagination.remove();
          this.$swpr_pagination = $('.swpr-pagination');
          $('.swiper-notification').remove();
          $('swiper-pagination-bullet').remove();
          this.$el.removeClass('is-active');
          this.$el.addClass('not-active');
        }
      },
      {
        key: '_initSlider',
        value: function _initSlider() {

          var _this = this;

          this.$swpr_root.removeAttr('class');
          this.$swpr_root.addClass('swiper');
          this.$swpr_container.removeAttr('class');
          this.$swpr_container.addClass('swiper-container');
          this.$swpr_wrapper.removeAttr('class');
          this.$swpr_wrapper.addClass('swiper-wrapper');
          this.$swpr_slides.removeAttr('class');
          this.$swpr_slides.addClass('swiper-slide');
          // this.$swpr_slides.addClass('swiper-slide el-product');
          this.$swpr_pagination.removeAttr('class');
          this.$swpr_pagination.addClass('swiper-pagination');
          this.$swpr_prevEl.removeAttr('class');
          this.$swpr_prevEl.addClass('swiper-btn-prev');
          this.$swpr_nextEl.removeAttr('class');
          this.$swpr_nextEl.addClass('swiper-btn-next');

          this.$swiper = new Swiper(this.$swpr_container, {
            slidesPerView: this.data.maxItemsPerView,
            slidesPerGroup: this.data.maxItemsPerView,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            spaceBetween: 32,
            direction: 'horizontal',
            loop: false,
            followFinger: $('html').hasClass('has-touch'),
            preventClicks: $('html').hasClass('has-touch'),
            simulateTouch: false,
            init: false,
            centeredSlides: false,
            navigation: {
              nextEl: this.$swpr_nextEl,
              prevEl: this.$swpr_prevEl,
            },
            pagination: {
              el: this.$swpr_pagination,
              clickable: true
            },
            breakpoints: this.data.breakpoints,
            on: {
              //   resize: function () {
              //     $('#shopify-section-{{ section.id }} .quickpreview').each(function() {
              //       if (!$(this).hasClass('hide')) {
              //         $(this).addClass('hide');
              //       }
              //     });
              //   },
              touchMove: function (e) {
                this.$el.find('.show-hoverview').removeClass('show-hoverview');
              },
              slideChange: function (e) {
                this.$el.find('.show-hoverview').removeClass('show-hoverview');
              },
              transitionStart: function (e) {
                this.$el.find('.show-hoverview').removeClass('show-hoverview');
              },
              transitionEnd: function (e) {
                this.$el.find('.show-hoverview').removeClass('show-hoverview');
              },
              sliderMove: function (e) {
                this.$el.find('.show-hoverview').removeClass('show-hoverview');
              },
            }
          });

          this.$el.removeClass('loading');
          this.$el.removeClass('not-active');
          this.$el.addClass('is-active');

          console.log(this.$swiper);

          this.$swiper.init();

        }
      }
    ]);
    return SliderMore;
  }();


  var Product = function () {
    function Product($el, sliderThis) {
      classCallCheck(this, Product);

      var _this = this;

      this.$el = $el;
      this.sliderThis = sliderThis;
      this.data = this._loadData(this.$el);

      this.$el.on("load:hoverview", function (e) {
        _this.$el.find('.hoverview').each(function () {
          return new HoverView($(this));
        });
      });

      if (Boolean(this.data.has_hoverview)) {
        this.$el.trigger("load:hoverview");
        // this.$el.find('.hoverview').each(function() {
        //     return new HoverView($(this));
        // });
      }

    }
    createClass(Product, [{
      key: '_loadData',
      value: function _loadData($el) {
        var dataEl = $el.find('[data-settings]');
        if (!dataEl.length) return {};
        // Load data from innerHTML
        var data = dataEl.html();
        try {
          return JSON.parse(data);
        } catch (error) {
          console.warn('Sections: invalid slider data found. ' + error.message);
          return {};
        }
      }
    }]);
    return Product;
  }();

  var Author = function () {
    function Author($el, sliderThis) {
      classCallCheck(this, Author);

      this.$el = $el;
      this.sliderThis = sliderThis;
      this.data = this._loadData(this.$el);

      if (Boolean(this.data.has_hoverview)) {
        this.$el.find('.hoverview').each(function () {
          return new HoverView($(this));
        });
      }

    }
    createClass(Author, [{
      key: '_loadData',
      value: function _loadData($el) {
        var dataEl = $el.find('[data-settings]');
        if (!dataEl.length) return {};
        // Load data from innerHTML
        var data = dataEl.html();
        try {
          return JSON.parse(data);
        } catch (error) {
          console.warn('Sections: invalid slider data found. ' + error.message);
          return {};
        }
      }
    }]);
    return Author;
  }();


  var HoverView = function () {
    function HoverView($el) {
      classCallCheck(this, HoverView);

      this.$el = $el;
      this._bindEvents = this._bindEvents.bind(this);
      this._bindEvents();

    }
    createClass(HoverView, [{
      key: '_bindEvents',
      value: function _bindEvents() {

        if ($('html').hasClass('has-touch')) {
          this.$el.on('touchstart', function (e) {
            e.preventDefault();
            if (e.target.tagName == 'BUTTON') {
              e.preventDefault();
              var $target = $(e.target);
              if ($target.data('quickshop') == '') {
                return new QuickShop($target);
              } else {
                return false;
              }
            } else {
              if (!$(this).hasClass('show-hoverview')) {
                $('.show-hoverview').removeClass('show-hoverview');
                $(this).addClass('show-hoverview');
              } else {
                window.location.href = $(this).attr('href');
              }
            }
          });
        } else {
          this.$el.on('click', function (e) {
            e.preventDefault();
            if (e.target.tagName == 'BUTTON') {
              e.preventDefault();
              var $target = $(e.target);
              if ($target.data('quickshop') == '') {
                return new QuickShop($target);
              } else {
                return false;
              }
            } else {
              window.location.href = $(this).attr('href');
            }
          });

        }
      }
    }]);
    return HoverView;
  }();

  var QuickShop = function () {

    function QuickShop($el) {
      classCallCheck(this, QuickShop);
      // this.$els = $('[data-quick-into-cart]');
      this.$el = $el;
      this.$cartCounter = $('[data-header-cart-count]');
      this.count = this.$cartCounter.attr('data-header-cart-count');

      this._onClick = this._onClick.bind(this);
      this._showFlyOut = this._showFlyOut.bind(this);
      this._closeFlyOut = this._closeFlyOut.bind(this);
      this._closeFlyOuts = this._closeFlyOuts.bind(this);
      this._handleDocumentClick = this._handleDocumentClick.bind(this);

      var _this = this;

      this._onClick();

    }

    createClass(QuickShop, [{
      key: '_onClick',
      value: function _onClick() {

        var _this = this;
        var icon = this.$el.find('i');
        icon.removeAttr("class");
        icon.attr("class", "fas fa-spinner fa-spin");

        this.$el.addClass('loading');

        return axios.post('/cart/add.js', {
          quantity: 1,
          id: _this.$el.data('variant-id')
        })
          .then(function (response) {
            icon.removeAttr("class");
            icon.attr("class", "fas fa-check");
            _this.$el.removeClass('loading');
            _this.$el.addClass('check');
            _this.$el.attr("disabled", "disabled");
            return _this._showFlyOut(response.data);
          })
          .catch(function (error) {
            icon.removeAttr("class");
            icon.attr("class", "fas fa-times");
            _this.$el.addClass('error');
            _this.$el.attr("disabled", "disabled");
          });
      }
    }, {
      key: '_showFlyOut',
      value: function _showFlyOut(data) {

        var _this = this;

        this.formData = {};
        this.settings = {};
        this.events = [];
        this.flyOutSelector = '[data-atc-banner]';
        this.$atcTemplate = $('[data-templates] ' + this.flyOutSelector);

        this.header = document.querySelector('.site-header-wrapper');
        this.$header = $(this.header);
        this.$body = $(document.body);

        // If any FlyOuts are fully open, close them
        this._closeFlyOuts();

        var $flyOut = this.$atcTemplate.clone();

        if (data.image) {
          var match = data.image.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
          var prefix = data.image.split(match[0]);
          var suffix = match[0];
          var path = prefix[0] + '_' + '200x' + suffix;
          var imageUrl = path.replace(/http(s)?:/, '')
          $flyOut.find('[data-atc-banner-product-image]').html('<img src="' + imageUrl + '" alt="' + data.product_title + '">');
        }

        $flyOut.find('[data-atc-banner-product-title]').text(data.product_title);
        // $flyOut.find('[data-atc-banner-product-title]').text(data.product_title + ' \xD7 ' + quantity);

        var $productPrice = $flyOut.find('[data-atc-banner-product-price]');
        var money_format = JSON.parse(this.$header.find('[data-section-data]').html()).currency.money_format;

        $productPrice.text(Shopify.formatMoney(data.price, money_format));
        var $subTotal = $flyOut.find('[data-atc-banner-cart-subtotal]');

        axios.get('/cart.js')
          .then(function (response) {

            $subTotal.text(Shopify.formatMoney(response.data.original_total_price, money_format));
            $flyOut.find('[data-atc-banner-cart-button]').find('span').text(response.data.item_count);
            _this.$body.append($flyOut);
            _this.$header.trigger('cartcount:update', {
              response: response.data
            });

            var headerHeight = _this.$header.outerHeight();

            $flyOut.css({
              top: headerHeight
            });

            $flyOut.on('click.atc-banner', '[data-atc-banner-close]', function (event) {
              event.preventDefault();
              _this._closeFlyOut($flyOut);
            });

            $(document).on('touchstart.atc-banner, click.atc-banner', _this._handleDocumentClick);

            $flyOut.addClass('animating animating-in').one('trend', function () {
              $flyOut.removeClass('animating animating-in').addClass('visible').off('trend');
              $flyOut.attr('data-flyout-active', true);
            });

          });
      }
    }, {
      key: '_handleDocumentClick',
      value: function _handleDocumentClick(event) {
        var target = event.target;
        var $parent = $(target).parents('[data-atc-banner]');

        if ($parent.length) {
          return;
        }

        this._closeFlyOuts();
      }
    }, {
      key: '_closeFlyOuts',
      value: function _closeFlyOuts() {
        var _this = this;
        $(this.flyOutSelector).filter('[data-flyout-active]').each(function (index, el) {
          var $flyOut = $(el);
          _this._closeFlyOut($flyOut);
        });
      }
    }, {
      key: '_closeFlyOut',
      value: function _closeFlyOut($flyOut) {
        var _this = this;
        $flyOut.addClass('animating animating-out').one('trend', function () {
          $flyOut.removeClass('animating animating-out visible').one('trend', function () {
            $flyOut.off('trend');
            $flyOut.remove();
          });
        });
      }
    }]);

    return QuickShop;

  }();


  var SectionNavigator = function () {

    function SectionNavigator(section) {

      classCallCheck(this, SectionNavigator);

      this.$el = $(section.el);
      this.$window = $(window);
      this.$sectionNavigation = this.$el.find('[data-section-navigation]');
      this.$sectionNav = this.$sectionNavigation.find('.nav');
      this.sectionNavHeight = this.$sectionNav.outerHeight();
      this.$shadowNav = this.$sectionNavigation.find('.nav-shadow');
      this.$fullHeader = $('#shopify-section-static-header-dragonfly');
      if (!this.$fullHeader.length) {
        this.$fullHeader = $('#shopify-section-static-header');
      }
      this.$header = this.$fullHeader.find('[data-site-header-main]');
      this.headerHeight = this.$header.outerHeight() + parseInt(this.$fullHeader.css("border-bottom-width"));
      this.$anchors = $('[data-scroll]');
      this.$btnSubmitCart = $('[data-product-atc]');
      this.$btnSubNavSubmitCart = $('[data-submit-cart]');

      this.fixed = false;
      this.scroll = window.scrollY + this.headerHeight;
      this.aboveAnySection = true;

      this.subNavSticky = this._subNavSticky.bind(this);
      this.subNavActive = this._subNavActive.bind(this);
      this.smoothScrollToSection = this._smoothScrollToSection.bind(this);
      this.sectionNavSubmitCart = this._sectionNavSubmitCart.bind(this);

      this.subNavSticky();
      this.$window.on('resize scroll', this.subNavSticky);
      $("body").on("position-banners", this.subNavSticky);

      this.subNavActive();
      this.$window.on('resize scroll', this.subNavActive);
      this.$anchors.on('click', this.smoothScrollToSection);

      if (this.$btnSubNavSubmitCart.length) {
        this.$btnSubNavSubmitCart.on('click', this.sectionNavSubmitCart);
      }

      /*
      var that = this;
      $("body").on("position-banners", function() {
          var headerFullHeight = that.$fullHeader.outerHeight();
          if (that.$fullHeader.outerHeight() < that.$sectionNav.position().top) {
            that.$sectionNav.css({ position: "fixed", top: headerFullHeight });
          }
      });
      */
    }

    createClass(SectionNavigator, [{
      key: '_sectionNavSubmitCart',
      value: function _sectionNavSubmitCart(event) {
        var _this = this;
        event.preventDefault();
        $('html, body').animate({
          scrollTop: 0
        }, 500);
        setTimeout(function () {
          _this.$btnSubmitCart.trigger('click');
        }, 500);
      }
    }, {
      key: '_isInViewport',
      value: function _isInViewport(el) {
        var elementTop = el.offset().top;
        var elementBottom = elementTop + el.outerHeight();
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();
        return elementBottom > viewportTop && elementTop < viewportBottom;
      }
    }, {
      key: '_subNavActive',
      value: function _subNavActive() {

        var _this = this;
        var top;
        this.aboveAnySection = true;

        if (this.fixed) {
          top = this.scroll + this.sectionNavHeight
        } else {
          top = this.scroll;
        }

        $('section[data-anchor]').each(function () {

          var $section = $(this).parent();

          var elementBegin = $section.offset().top;
          var elementEnd = elementBegin + $section.outerHeight();

          if (top > elementBegin && top < elementEnd) {
            var target = $(this).data('anchor');
            $('a[data-scroll].active').removeClass('active');
            $('a[href="' + target + '"').addClass('active');
            _this.aboveAnySection = false;
          }

        });

        if (this.aboveAnySection) {
          $('a[data-scroll].active').removeClass('active');
        }

      }
    }, {
      key: '_subNavSticky',
      value: function _subNavSticky() {

        this.scroll = window.scrollY + this.headerHeight;

        if (this.fixed) {

          if ($('#shopify-section-static-header-dragonfly').length) {
            this.subNavFromTop = this.$shadowNav.offset().top;
          } else {
            this.subNavFromTop = this.$shadowNav.offset().top - $('[data-site-metanav-harpercollins]').outerHeight() - 2;
          }

          if (this.scroll <= this.subNavFromTop) {
            this.fixed = false;
            this.$shadowNav.empty();
            this.$sectionNav.css({ position: "", top: "" });
          } else {
            var headerFullHeight = this.$fullHeader.outerHeight();
            if (this.$fullHeader.outerHeight() < this.$sectionNav.position().top) {
              this.$sectionNav.css({ position: "fixed", top: headerFullHeight });
            }
          }

        } else {

          if ($('#shopify-section-static-header-dragonfly').length) {
            this.subNavFromTop = this.$shadowNav.offset().top - this.sectionNavHeight;
          } else {
            this.subNavFromTop = this.$shadowNav.offset().top - this.sectionNavHeight - $('[data-site-metanav-harpercollins]').outerHeight() + 2;
          }

          if (this.scroll >= this.subNavFromTop) {

            this.fixed = true;
            this.$sectionNav.clone().appendTo(this.$shadowNav);

            if ($('#shopify-section-static-header-dragonfly').length) {
              this.$sectionNav.css({ position: "fixed", top: this.headerHeight });
            } else {
              var headerFullHeight = this.$fullHeader.outerHeight();
              this.$sectionNav.css({ position: "fixed", top: headerFullHeight });
            }
          }

        }

      }
    }, {
      key: '_smoothScrollToSection',
      value: function _smoothScrollToSection(event) {
        var _this = this;
        event.preventDefault();
        var $targetSection = $("[data-anchor='" + $(event.target).attr('href') + "']").parent();
        $('html, body').animate({
          scrollTop: $targetSection.offset().top - _this.headerHeight
        }, 500);
      }
    }]);

    return SectionNavigator;

  }();

  var SectionLeseprobe = function () {

    function SectionLeseprobe(section) {

      classCallCheck(this, SectionLeseprobe);

      this.$el = $(section.el);
      this.data = section.data
      this.$leseprobe = this.$el.find('[data-leseprobe]');
      this.$window = $(window);
      this.$sectionNavigation = this.$el.find('[data-section-navigation]');
      this.$closeExcerptWrapper = this.$el.find('[data-close-excerpt-wrapper]');
      this.$closeExcerptBtn = this.$closeExcerptWrapper.find('button');
      this.$fullHeader = $('#shopify-section-static-header-dragonfly');
      if (!this.$fullHeader.length) this.$fullHeader = $('#shopify-section-static-header');
      this.$header = this.$fullHeader.find('[data-site-header-main]');
      this.headerHeight = this.$header.outerHeight() + parseInt(this.$fullHeader.css("border-bottom-width"));
      this.$sectionNavigation = $('[data-section-navigation]');
      this.$sectionNav = this.$sectionNavigation.find('.nav');
      this.sectionNavHeight = this.$sectionNav.outerHeight();

      this._loadLeseprobe = this._loadLeseprobe.bind(this);
      this._truncateLeseprobe = this._truncateLeseprobe.bind(this);
      this._maybeScrollTop = this._maybeScrollTop.bind(this);
      this._isInViewport = this._isInViewport.bind(this);
      this._closeExcerpt = this._closeExcerpt.bind(this);

      this._loadLeseprobe(section);

      this.$window.on('resize scroll', this._maybeScrollTop);
      this.$closeExcerptBtn.on('click', this._closeExcerpt);

    }

    createClass(SectionLeseprobe, [{
      key: '_loadLeseprobe',
      value: function _loadLeseprobe(section) {

        var _this = this;
        let has_Bilderleseprobe;
        try {
          has_Bilderleseprobe = _this.data.context.has_bilderleseprobe;
        }
        catch (e) {
          has_Bilderleseprobe = null;
        }
        //console.log(_this.data.context);

        if (has_Bilderleseprobe == false) {
          //if (!_this.data.context.has_bilderleseprobe) {

          // Erscheinungs Datum höchstens 30 Tage in der Zukunft
          var one_month = 1000 * 60 * 60 * 24 * 30;
          var evt_tokens = _this.data.context.evt.split(".");
          var evt_date = new Date(evt_tokens[2] + "-" + evt_tokens[1] + "-" + evt_tokens[0]);

          /*console.log(_this.data.context.evt);
          console.log(evt_date.getTime() - one_month);
          console.log(new Date().getTime())*/

          if ((evt_date.getTime() - one_month) < new Date().getTime()) {
						if(section.data.leseprobe_exists == false)
						{
							$.get("https://harper-collins.herokuapp.com/public/leseprobe_v2/"+section.data.isbn_leseprobe+"?shopify_domain=harper-collins.myshopify.com", function (response) {
								var $excerpt = $($.parseHTML(response));
								if ($excerpt.length) {
									$excerpt.find('svg').remove();
									$excerpt.find('img').remove();
									$excerpt.find('p[class^="copy"]').remove();
									_this.$leseprobe.html($excerpt);
									_this._truncateLeseprobe();
								} else {
									if (!_this.data.context.has_bilderleseprobe) {
										$('#shopify-section-product-leseprobe').remove();
										$('a[href="#leseprobe"]').parent().remove();
									}
								}
							}).fail(function (error) {
								$('#shopify-section-product-leseprobe').remove();
								$('a[href="#leseprobe"]').parent().remove();
							});
						}
						else
						{
							_this._truncateLeseprobe();
							$( '#excerpt img' ).remove();
							$( '#excerpt p[class^="copy"]' ).remove();
						}
          } 
					else 
					{
            $('#shopify-section-product-leseprobe').remove();
            $('a[href="#leseprobe"]').parent().remove();
          }

        }
      }
    }, {
      key: '_truncateLeseprobe',
      value: function _truncateLeseprobe() {
        var _this = this;

        this.$excerpt = $('#excerpt');
        this.$btnOpen = $('button#open');
        this.excerptHeight = this.$excerpt.height();
        this.excerptMaxHeight = parseInt(this.$excerpt.find('p').first().css('line-height'), 10) * 20;
        this.$excerpt.height(this.excerptMaxHeight + 'px');

        this.$btnOpen.click(function () {
          var size = null;
          if (_this.$excerpt.height() == _this.excerptMaxHeight) {
            size = _this.excerptHeight
            _this.$btnOpen.html(_this.data.context.read_less);
            _this.$excerpt.addClass('opened');
          } else {
            size = _this.excerptMaxHeight
            _this.$btnOpen.html(_this.data.context.read_more);
            _this.$excerpt.removeClass('opened');
          }
          // _this.$excerpt.height() == _this.excerptMaxHeight ? size = _this.excerptHeight : size = _this.excerptMaxHeight;
          _this.$excerpt.animate({ height: size + 'px' }, 500);
          // $(_this).remove();
        });

      }
    }, {
      key: '_closeExcerpt',
      value: function _closeExcerpt(el) {
        var _this = this;
        var size = null;
        this.$btnOpen.html(this.data.context.read_more);
        this.$excerpt.removeClass('opened');
        $("html, body").animate({
          scrollTop: this.$el.offset().top - this.headerHeight - this.sectionNavHeight
        }, 500);
        setTimeout(function () {
          _this.$excerpt.animate({ height: _this.excerptMaxHeight + 'px' }, 500);
        }, 500);
        this.$closeExcerptWrapper.removeClass('show');
      }
    }, {
      key: '_isInViewport',
      value: function _isInViewport(el) {
        var elementTop = el.offset().top;
        var elementBottom = elementTop + el.outerHeight();
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();
        return elementBottom > viewportTop && elementTop < viewportBottom;
      }
    }, {
      key: '_maybeScrollTop',
      value: function _maybeScrollTop() {
        var _this = this;
        if (this.$excerpt && this.$excerpt.hasClass('opened')) {
          if (this._isInViewport(this.$excerpt)) {
            this.$closeExcerptWrapper.addClass('show')
          }
        }
      }
    }]);

    return SectionLeseprobe;

  }();

  var RichText = function () {

    function RichText(section) {

      classCallCheck(this, RichText);

      this.data = section.data;
      this.$el = $(section.el);
      this.$richTextContainer = this.$el.find('.rich-text--container');
      this.containerHeight = this.$richTextContainer.height();
      this.containerMaxHeight = 300;


      this._truncateBlock = this._truncateBlock.bind(this);
      this._onClick = this._onClick.bind(this);

      var _this = this;

      // this.$els.each(function() {
      //     $(this).click(function() {
      //         _this._onClick($(this));
      //     });
      // });

      if (this.data.make_folding) {
        //this._truncateBlock();
        this.$richTextContainer.removeClass('make-folding');
        this.$unfoldButton = this.$el.find('button.rich-text-unfold');
        this.$unfoldButton.click(function () {
          _this._onClick();
        });
      }

    }

    createClass(RichText, [{
      key: '_truncateBlock',
      value: function _truncateBlock() {
        var size = null;
        if (this.$richTextContainer.height() == this.containerMaxHeight) {
          size = this.containerHeight;
        } else {
          size = this.containerMaxHeight;
        }
        this.$richTextContainer.animate({ 'height': size + 'px' }, 500);
      }
    }, {
      key: '_onClick',
      value: function _onClick(el) {
        var _this = this;
        var size = null;
        if (this.$richTextContainer.height() == this.containerMaxHeight) {
          size = this.containerHeight;
          this.$richTextContainer.removeClass('make-folding');
        } else {
          size = this.containerMaxHeight;
          this.$richTextContainer.addClass('make-folding');
        }
        this.$richTextContainer.animate({ 'height': size + 'px' }, 500);
      }
    }]);

    return RichText;

  }();

  var FeaturedCollection = function () {

    function FeaturedCollection(section) {

      classCallCheck(this, FeaturedCollection);

      var _this = this;

      this.data = section.data;

      this.$swiper = null;
      this.$el = $(section.el);
      this.$swpr_root = this.$el.find('.swpr');
      this.$swpr_container = this.$el.find('.swpr-container');
      this.$swpr_wrapper = this.$el.find('.swpr-wrapper');
      this.$swpr_slides = this.$el.find('.swpr-slide');
      this.$swpr_pagination = this.$el.find('.swpr-pagination');

      this.$swpr_prevEl = this.$el.find('.swpr-btn-prev');
      this.$swpr_nextEl = this.$el.find('.swpr-btn-next');

      this._resetSwiper = this._resetSwiper.bind(this);
      this._checkAndBuildSwiper = this._checkAndBuildSwiper.bind(this);

      this._checkAndBuildSwiper();
      $(window).resize(this._checkAndBuildSwiper);


    }

    createClass(FeaturedCollection, [
      {
        key: '_resetSwiper',
        value: function _resetSwiper() {

          this.$swiper.destroy(true, false);
          this.$swiper = null;
          this.$swpr_prevEl.removeAttr('class');
          this.$swpr_prevEl.addClass('swpr-btn-prev');
          this.$swpr_nextEl.removeAttr('class');
          this.$swpr_nextEl.addClass('swpr-btn-next');
          this.$swpr_root.removeAttr('class');
          this.$swpr_root.addClass('swpr');
          this.$swpr_container.removeAttr('class');
          this.$swpr_container.addClass('swpr-container');
          this.$swpr_wrapper.removeAttr('class');
          this.$swpr_wrapper.removeAttr('style');
          this.$swpr_wrapper.addClass('swpr-wrapper');
          this.$swpr_wrapper.addClass('gridlex-equalHeight');
          this.$swpr_wrapper.addClass('grid-products');
          this.$swpr_slides.each(function (index, el) {
            var $el = $(this);
            var add_class = '';
            if ($el.hasClass('preprelast')) {
              add_class = 'preprelast';
            } else if ($el.hasClass('prelast')) {
              add_class = 'prelast';
            } else if ($el.hasClass('last')) {
              add_class = 'last';
            }
            $el.removeAttr('class');
            $el.removeAttr('style');
            $el.addClass('col');
            $el.addClass('swpr-slide');
            $el.addClass(add_class);
          })
          $('<div class="swpr-pagination"></div>').insertAfter(this.$swpr_pagination);
          this.$swpr_pagination.remove();
          this.$swpr_pagination = $('.swpr-pagination');
          $('.swiper-notification').remove();
          $('swiper-pagination-bullet').remove();

        }
      },
      {
        key: '_checkAndBuildSwiper',
        value: function _checkAndBuildSwiper() {
          var _this = this;

          if (window.innerWidth >= this.data.trigger_swiper) {

            if (this.$swiper) {
              return this._resetSwiper();
            }

          } else {

            if (!this.$swiper) {

              this.$swpr_root.removeAttr('class');
              this.$swpr_root.addClass('swiper');
              this.$swpr_container.removeAttr('class');
              this.$swpr_container.addClass('swiper-container');
              this.$swpr_wrapper.addClass('swiper-wrapper');
              this.$swpr_wrapper.removeClass('gridlex-equalHeight');
              this.$swpr_slides.addClass('swiper-slide');
              this.$swpr_slides.removeClass('col');
              this.$swpr_pagination.removeAttr('class');
              this.$swpr_pagination.addClass('swiper-pagination');
              this.$swpr_prevEl.removeAttr('class');
              this.$swpr_prevEl.addClass('swiper-btn-prev');
              this.$swpr_nextEl.removeAttr('class');
              this.$swpr_nextEl.addClass('swiper-btn-next');

              return this.$swiper = new Swiper(this.data.slider_class, {
                slidesPerView: 2,
                slidesPerGroup: 2,
                spaceBetween: 16,
                direction: 'horizontal',
                loop: false,
                followFinger: false,
                preventClicks: false,
                simulateTouch: false,
                centeredSlides: false,
                navigation: {
                  nextEl: this.data.slider_nextEl_class,
                  prevEl: this.data.slider_prevEl_class,
                },
                pagination: {
                  el: this.data.slider_pagination_class,
                  clickable: true
                }
              });

            }

          }

        }
      }
    ]);

    return FeaturedCollection;

  }();

  var StaticHeader = function () {
    function StaticHeader(section) {
      var _this = this;

      classCallCheck(this, StaticHeader);

      this.postMessage = section.postMessage;
      this.$el = $(section.el);
      this.$window = $(window);
      this.$html = $('html');
      this.$body = $('body');

      this.$meganav = this.$el.find('[data-site-meganav]');
      this.$menuToggle = this.$el.find('[data-menu-toggle]');
      this.$navmenuItems = this.$el.find('.navmenu-item');
      this.$closeMenuButton = this.$el.find('[data-meganav-mobile-close]');
      this.$secondarymenu = $('[data-site-secondarymenu]');

      this.$metanavdragonfly = $('[data-site-metanav-dragonfly]');

      this.$navmenuContainer = $('.navmenu-container');
      this.$supernav = $('[data-site-supernav]');

      this.is_mobile_nav = this.$window.width() < 1024;
      this.maybe_mobile_supernav = this.$window.width() < 450;
      this.hasTouch = this.$html.hasClass('has-touch');

      this._checkMobileNav = this._checkMobileNav.bind(this);
      this._menuToggle = this._menuToggle.bind(this);
      this._closeMenu = this._closeMenu.bind(this);
      this._cloneAppendSecondaryMenu = this._cloneAppendSecondaryMenu.bind(this);
      this._cloneAppendMetaNavDragonfly = this._cloneAppendMetaNavDragonfly.bind(this);
      this._cloneAppendSupernavMenu = this._cloneAppendSupernavMenu.bind(this);
      this._navitemTrigger = this._navitemTrigger.bind(this);
      this._navitemHover = this._navitemHover.bind(this);
      this._navitemToggle = this._navitemToggle.bind(this);

      this.$window.on('resize', this._checkMobileNav);
      this.$window.on('resize', this._navitemTrigger);
      this._navitemTrigger();

      this.$menuToggle.on('click', this._menuToggle);
      this.$closeMenuButton.on('click', this._closeMenu);


    }

    createClass(StaticHeader, [{
      key: '_navitemTrigger',
      value: function _navitemTrigger(e) {
        var _this = this;
        this.$navmenuItems.each(function () {
          if ($(this).hasClass('trigger')) {
            if (_this.is_mobile_nav) {
              _this._navitemToggle($(this));
            } else {
              if (_this.hasTouch) {
                _this._navitemToggle($(this));
              } else {
                _this._navitemHover($(this));
              }
            }

            $(this).find('.subnav a').click(function (e) {
              e.stopPropagation();
            });
          }
        });
      }
    }, {
      key: '_navitemHover',
      value: function _navitemHover($target) {
        var _this = this;
        $target.unbind('click');
        $target.hover(
          function (e) {
            $(this).addClass('show');
          },
          function (e) {
            $(this).removeClass('show');
          }
        );
      }
    }, {
      key: '_navitemToggle',
      value: function _navitemToggle($target) {
        var _this = this;
        $target.unbind('hover');
        $target.click(
          function (e) {
            e.preventDefault();
            if (!$(this).hasClass('show')) {
              $('.navmenu-item.trigger.show').removeClass('show');
            }
            $(this).toggleClass('show');
            _this.$meganav.animate({
              scrollTop: 0
            }, 500);
            /*
            var $target = $(e.target);
            if ($target.parent('.navmenu-item').length) {
                if (!$(this).hasClass('show')) {
                    // _this.$navmenuItems.find('.trigger.show').removeClass('show');
                    $('.navmenu-item.trigger.show').removeClass('show');
                }
                $(this).toggleClass('show');
                _this.$meganav.animate({
                    scrollTop: 0
                }, 500);
            } else if ($target.prop("tagName") == 'A') {
                window.location.href = $target.attr('href');
            }
            */
          }
        );
      }
    }, {
      key: '_menuToggle',
      value: function _menuToggle(e) {
        e.preventDefault();
        var _this = this;
        if (this.is_mobile_nav) {
          $('.trigger.show').removeClass('show');
          this.$body.toggleClass('curtain');
          this.$meganav.addClass('animating animating-in').one('trend', function () {
            _this.$meganav.removeClass('animating animating-in').addClass('visible').off('trend');
            // _this._cloneAppendMetaNavDragonfly();
            _this._cloneAppendSupernavMenu();
            _this._cloneAppendSecondaryMenu();
          });
        }
      }
    }, {
      key: '_cloneAppendMetaNavDragonfly',
      value: function _cloneAppendMetaNavDragonfly() {
        var _this = this;
        if (this.is_mobile_nav) {
          this.$metanavdragonfly.clone().addClass('metanavdragonfly-list').appendTo(this.$navmenuContainer);
          this.$metanavdragonflyList = this.$navmenuContainer.find('.metanavdragonfly-list');
        }
      }
    }, {
      key: '_cloneAppendSecondaryMenu',
      value: function _cloneAppendSecondaryMenu() {
        var _this = this;
        if (this.is_mobile_nav) {
          this.$secondarymenu.addClass('secondarymenu-list').appendTo(this.$navmenuContainer);
          // this.$secondarymenu.clone().addClass('secondarymenu-list').appendTo(this.$navmenuContainer);
          // this.$secondarymenuList = this.$navmenuContainer.find('.secondarymenu-list');
        }
      }
    }, {
      key: '_cloneAppendSupernavMenu',
      value: function _cloneAppendSupernavMenu() {
        var _this = this;
        if (this.maybe_mobile_supernav) {
          this.$supernav.children().each(function () {
            if (!$(this).hasClass('warenkorb')) {
              $(this).prependTo(_this.$secondarymenu);
            }
          });
          // this.$supernav.clone().addClass('supernavmenu-list').appendTo(this.$navmenuContainer);
          // this.$supernavmenuList = this.$navmenuContainer.find('.supernavmenu-list');
          // this.$supernavmenuList.find('.warenkorb').remove();
        }
      }
    }, {
      key: '_closeMenu',
      value: function _closeMenu(e) {
        e.preventDefault();
        var _this = this;
        this.$body.removeClass('curtain');
        this.$meganav.addClass('animating animating-out').one('trend', function () {
          _this.$meganav.removeClass('animating animating-out').removeClass('visible').off('trend');
          _this.$body.removeClass('scroll-lock');
          $('[data-site-secondarymenu]').children().each(function () {
            if ($(this).hasClass('konto')) {
              $(this).prependTo('[data-site-supernav]');
            }
          });
          _this.$secondarymenu.removeClass('secondarymenu-list').appendTo('.site-header.desktop .site-metanav');
          // _this.$secondarymenuList.remove();
          // _this.$secondarymenuList = null;
          _this.$metanavdragonflyList.remove();
          _this.$metanavdragonflyList = null;
          _this.$meganav.removeClass('visible');
        });
      }
    }, {
      key: '_checkMobileNav',
      value: function _checkMobileNav(section) {
        this.is_mobile_nav = this.$window.width() < 1024;
        this.maybe_mobile_supernav = this.$window.width() < 450;
      }
    }]);
    return StaticHeader;
  }();

  var ProductReviews = function () {
    function ProductReviews(section) {
      var _this = this;

      classCallCheck(this, ProductReviews);

      this.postMessage = section.postMessage;
      this.$el = $(section.el);
      this.$scrollToReviews = $('[data-scroll-to-reviews]');

      this.$fullHeader = $('#shopify-section-static-header-dragonfly');
      if (!this.$fullHeader.length) this.$fullHeader = $('#shopify-section-static-header');
      this.$header = this.$fullHeader.find('[data-site-header-main]');
      this.headerHeight = this.$header.outerHeight() + parseInt(this.$fullHeader.css("border-bottom-width"));
      this.$sectionNavigation = $('[data-section-navigation]');
      this.$sectionNav = this.$sectionNavigation.find('.nav');
      this.sectionNavHeight = this.$sectionNav.outerHeight();

      this._scrollToReviews = this._scrollToReviews.bind(this);

      this.$scrollToReviews.on('click', this._scrollToReviews);

    }

    createClass(ProductReviews, [{
      key: '_scrollToReviews',
      value: function _scrollToReviews() {

        console.log(this.$header);

        $("html, body").animate({
          scrollTop: this.$el.offset().top - this.headerHeight - this.sectionNavHeight
        }, 500);
      }
    }]);
    return ProductReviews;
  }();




  var FilterBox = function () {
    function FilterBox($el) {

      var _this = this;

      this.$el = $el;
      this._toggleFilterBox = this._toggleFilterBox.bind(this);
      this._handleDocumentClick = this._handleDocumentClick.bind(this);
      this._untoggleFilterBox = this._untoggleFilterBox.bind(this);
      this._setSortByQueryParameters = this._setSortByQueryParameters.bind(this);
      this._checkListView = this._checkListView.bind(this);


      // $(document).on('touchstart, click', this._handleDocumentClick);
      this._toggleFilterBox();
      this._setSortByQueryParameters();

    }

    createClass(FilterBox, [{
      key: '_toggleFilterBox',
      value: function _toggleFilterBox() {

        if ($('html').hasClass('has-touch')) {
          this.$el.click(function (e) {
            var $target = $(e.target);
            if (e.target.tagName != 'A') {
              $(this).toggleClass('toggle');
            }
          });
        } else {
          this.$el.hover(
            function (e) {
              $(this).addClass('toggle');
            },
            function (e) {
              $(this).removeClass('toggle');
            }
          );
        }

        var change = false;

        this.$el.find('a').click(function (e) {
          e.preventDefault();
          if (!change) {
            change = true;
            // var $target = $(e.target)
            var $target = $(this);
            $target.parent().toggleClass('active');
            setTimeout(function () {
              if ($target.data('sort-by') && $target.data('sort-by') != '') {
                Shopify.queryParams.sort_by = $target.data('sort-by');
                location.search = $.param(Shopify.queryParams).replace(/\+/g, '%20');
              } else if ($target.data('view-as') && $target.data('view-as') != '') {
                Shopify.queryParams.grid_list = $target.data('view-as');
                location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
              } else {
                window.location.href = $target.attr('href');
              }
            }, 1000);
          } else {
            return false;
          }
        })

      }
    }, {
      key: '_handleDocumentClick',
      value: function _handleDocumentClick(event) {
        // var target = event.target;
        // var $parent = $(target).parents('[data-filter-select-box]');
        // if ($parent.length) {
        //     return;
        // }
        // this._untoggleFilterBox();
        // console.log(this.$el == $(target));
      }
    }, {
      key: '_untoggleFilterBox',
      value: function _untoggleFilterBox(event) {
        $('.filter-select-box.toggle').removeClass('toggle');
      }
    }, {
      key: '_setSortByQueryParameters',
      value: function _setSortByQueryParameters() {
        Shopify.queryParams = {};
        if (location.search.length) {
          for (var i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
            var aKeyValue = aCouples[i].split('=');
            // Reset the page number when we apply (i.e. don't add it to params)
            if (aKeyValue.length > 1 && aKeyValue[0] !== 'page') {
              Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
            }
          }
        }
        this._checkListView();
      }
    }, {
      key: '_checkListView',
      value: function _checkListView() {
        if (Shopify.queryParams.grid_list === 'list-view') {
          $('.top-utils').find('[href*="&grid_list"]').attr('href', function (i, href) {
            if (href.indexOf('?') === -1) {
              href = href.replace('&', '?');
            }
            return href.replace('grid_list', 'grid_list=list-view');
          });
          $('[data-view-as="list-view"]').parent().addClass('active');
          $('.grid-products').removeClass('gridview');
          $('.grid-products').addClass('listview');
          // $('.top-utils').find('.utils-viewtoggle-button').removeClass('active');
          // this.$listViewToggle.addClass('active');
          // this.$gridContainer.addClass('productgrid-listview');
        } else {
          $('[data-view-as="grid-view"]').parent().addClass('active');
          $('.top-utils').find('[href*="&grid_list"]').attr('href', function (i, href) {
            if (href.indexOf('?') === -1) {
              href = href.replace('&', '?');
            }
            return href.replace('grid_list', 'grid_list=grid-view');
          });
        }
      }
    }]);
    return FilterBox;
  }();




  var NavigationMiniserie = function () {
    function NavigationMiniserie() {

      var _this = this;

      this.$el = $('[data-nav-miniserie]');

      this.$triggerNav = this.$el.find('[data-trigger-nav]');
      this.$elTriggers = this.$el.find('[data-trigger-list-item]');

      this._toggleNav = this._toggleNav.bind(this);
      this._toggleNavItem = this._toggleNavItem.bind(this);

      this.$triggerNav.click(this._toggleNav);

      this.$elTriggers.each(this._toggleNavItem);

    }

    createClass(NavigationMiniserie, [{
      key: '_toggleNav',
      value: function _toggleNavItem(e) {

        var _this = this;

        if (e.target.tagName != 'SPAN') {
          e.preventDefault();
          _this.$el.find('.second-level-list').toggleClass('nav-show');
          // if(_this.$triggerNav.hasClass('nav-show')) {
          //     _this.$triggerNav.removeClass('nav-show');
          // } else {
          //     _this.$triggerNav.addClass('nav-show');
          // }
        }
      }
    }, {
      key: '_toggleNavItem',
      value: function _toggleNavItem(index, el) {
        $(el).click(function (e) {
          if (e.target.tagName != 'A') {
            if ($(this).hasClass('active')) {
              $(this).removeClass('active');
              $(this).addClass('not-active');
            } else {
              $(this).removeClass('not-active');
              $(this).addClass('active');
            }
          }
        });
      }
    }]);
    return NavigationMiniserie;
  }();



  var Collection = function () {

    function Collection(section) {
      var _this = this;
      classCallCheck(this, Collection);
      this.postMessage = section.postMessage;
      this.$el = $(section.el);

      if (section.data.is_filtered) {
        this.moveToProducts();
      }
    }

    createClass(Collection, [{
      key: 'moveToProducts',
      value: function moveToProducts() {
        var _this = this;

        var $header = $('[data-site-header-main]');
        $(document).scrollTop(this.$el.find('.product-list .grid-products').offset().top - $header.height() - 20);

        // $('html, body').scrollTop(this.$el.find('.product-list .grid-products').offset().top);
        // setTimeout(function() {
        //     $('html, body').animate({
        //         scrollTop: _this.$el.find('.product-list .grid-products').offset().top
        //     }, 100);
        // }, 500);
      }
    }]);

    return Collection;

  }();




  var sections = new Sections();

  sections.register('static-product', function (section) {
    return new StaticProduct(section);
  });

  sections.register('product-leseprobe', function (section) {
    return new SectionLeseprobe(section);
  });

  sections.register('product-navigation', function (section) {
    return new SectionNavigator(section);
  });

  sections.register('product-reviews', function (section) {
    return new ProductReviews(section);
  });

  sections.register('author-navigation', function (section) {
    return new SectionNavigator(section);
  });

  sections.register('dynamic-rich-text', function (section) {
    return new RichText(section);
  });

  sections.register('featured-collection', function (section) {
    return new FeaturedCollection(section);
  });

  sections.register('static-header', function (section) {
    return new StaticHeader(section);
  });

  sections.register('collection', function (section) {
    return new Collection(section);
  });

  $(window).on("new:Product", function (e) {
    $('[data-el-product]').each(function () {
      return new Product($(this), null);
    });
  });

  if ($('[data-el-product]').length) {
    $(window).trigger("new:Product");
  }

  // $('[data-el-product]').each(function() {
  //     return new Product($(this), null);
  // });

  $('[data-el-author]').each(function () {
    return new Author($(this), null);
  });

  $('[data-slider]').each(function () {
    return new Slider($(this));
  });

  $('[data-slider-more]').each(function () {
    return new SliderMore($(this));
  });

  $('[data-filter-select-box]').each(function () {
    return new FilterBox($(this));
  });

  $('[data-slider-home]').each(function () {
    return new SliderHome($(this));
  });

  var NavigationMiniserie = new NavigationMiniserie();

});
